import { isNumber } from 'lodash/fp'
import formatNumber, { COUNTER_LIMIT } from 'helpers/formatNumber'
import { FC, PropsWithChildren } from 'react'
import { cn, TooltipWrapper } from '@wellesley/ui'

type CardActionProps = PropsWithChildren<{
  name: string
  value?: number | string
  handler(): void
  disabled?: boolean
  className?: string
  hideValue?: boolean
}>

const CardAction: FC<CardActionProps> = ({
  name,
  value,
  children,
  handler,
  hideValue = false,
  disabled,
  className,
}) => (
  <div
    data-testid={`${name}-button`}
    className={cn(
      'flex cursor-pointer items-center justify-center text-gray-600',
      disabled && 'opacity-[.5]',
      className,
    )}
    onClick={disabled ? undefined : handler}
  >
    {children}
    {!hideValue &&
      (isNumber(value) ? (
        <TooltipWrapper
          size="small"
          theme="dark"
          tooltipText={value > COUNTER_LIMIT ? `${value}` : ''}
          triggerProps={{
            asChild: true,
          }}
        >
          <p className="ml-xxxs text-sm font-semibold">{formatNumber(value)}</p>
        </TooltipWrapper>
      ) : (
        <p className="ml-xxxs text-sm font-semibold">{value}</p>
      ))}
  </div>
)

export { CardAction }
